import Cookies from 'js-cookie';
import {MOCK_CURRENT_DATE_COOKIE} from '../constants';
import {HttpMethod, AxiosError} from './types';

// Only accept requests to the session that return 2XX
export const ValidJoinServicesRequest = (status) => {
  return status >= 200 && status < 300;
};

// If response --> Request was made and the server responded
// If request --> no response (timeout)
export const createAxiosError = (error, method: HttpMethod): AxiosError => {
  const res: any = error.response;
  const req: any = error.request;
  const isAxiosError: boolean = error.isAxiosError;
  return {
    message: error.message,
    response: res,
    request: req,
    isAxiosError: isAxiosError,
    method: method
  };
};

export const isValidDate = (date: Date): boolean => date instanceof Date && !isNaN(date.getTime());

export const isDateStringInFuture = (effectiveProductDate: string | undefined) => {
  if (effectiveProductDate) {
    return new Date(effectiveProductDate) > new Date();
  }
  return false;
};

export const isValidISODateFormat = (dateString: string | undefined | null): boolean => {
  if (!dateString) return false;

  return /^\d{4}-\d{2}-\d{2}$/.test(dateString);
};

export const getMockCurrentDate = (): string | undefined => {
  if (process.env.GATSBY_ENVIRONMENT === 'kaos' || process.env.GATSBY_ENVIRONMENT === 'local') {
    const mockDate = Cookies.get(MOCK_CURRENT_DATE_COOKIE);
    if (isValidISODateFormat(mockDate) && isDateStringInFuture(mockDate)) {
      return mockDate;
    }
  }
  return;
};

export const getCurrentDate = (): Date => {
  const mockedCurrentDate = getMockCurrentDate();
  return mockedCurrentDate ? new Date(mockedCurrentDate) : new Date();
};
